module.exports = __webpack_public_path__ + "static/media/ATM-BNB.c7d760a8.svg";